<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading [level]="2" fudisDialogTitle>{{ values.title | transloco }}</fudis-heading>
    <fudis-dialog-content [contentFocus]="true">
      <fudis-grid [classes]="'fudis-my-md'">
        @for (notification of notifications; track notification) {
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>
              {{ notification }}
            </fudis-body-text>
          </fudis-notification>
        }
        @for (description of descriptions; track description) {
          <fudis-body-text>{{ description | transloco }}</fudis-body-text>
        }
      </fudis-grid>
    </fudis-dialog-content>
    <fudis-dialog-actions>
      @if (!values.hideCancel) {
        <fudis-button
          variant="secondary"
          fudisDialogClose
          [label]="values.cancelText ? t(values.cancelText) : t('SIS_COMPONENTS.BUTTON.CANCEL')" />
      }
      <fudis-button
        data-cy="confirm-dialog-confirm"
        [label]="values.confirmText ? t(values.confirmText) : t('SIS_COMPONENTS.BUTTON.SAVE')"
        (handleClick)="close()" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
